import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.colors.background};
`
export const GeneralWrapper = styled.div``
export const RowWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  min-height: 80px;
  padding: 0 40px;
  border-bottom: 2px solid ${({ theme }) => theme.colors.backgroundLite};

  & button {
    border-radius: 5px;
  }
`
export const RowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 25px;
  min-width: 200px;

  // overwriting select component
  & div > div {
    margin: 0 !important;
  }
`
export const ColWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`
export const Title = styled.h2`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primary};
`
export const Text = styled.p`
  margin: 0;
  font-size: 11px;
  color: ${({ theme }) => theme.colors.primary};
`
